import { PAYMENT_TYPE, SEQUENCER_MANAGEMENT_TYPE } from './rollupConst';
import { IDeployRollupFormPayload } from './types/rollupFormTypes';

export const deployRollupInitialState: IDeployRollupFormPayload = {
  planUuid: '',
  stack: '',
  grade: '',
  dataAvailabilityLayer: '',
  l1Chain: '',
  parachainTemplate: '',
  coretimeOption: '',
  networkAccess: '',
  sequencerManagementType: SEQUENCER_MANAGEMENT_TYPE.product,
  sequencerAddress: '',
  sequencerUrl: '',
  chainId: '',
  networkName: '',
  tokenName: '',
  gasToken: '',
  gasTokenAddress: '',
  optionalSettings: [],
  explorerSettings: undefined,
  paymentType: PAYMENT_TYPE.stripe,

  connectType: '',
  telegramUsername: '',
  slackEmail: '',
};
